import {HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {catchError, from, Observable, switchMap, take, throwError} from "rxjs";
import {AuthService} from "./services/auth/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return from(authService.getTokens()).pipe(take(1)).pipe(
    switchMap(tokens => {
      let observable: Observable<HttpEvent<unknown>>;
      if (tokens === undefined) {
        observable = next(req);
      } else {
        observable = next(req.clone({
          setHeaders: { Authorization: `Bearer ${tokens.accessToken}` },
        }));
      }

      return observable.pipe(
        catchError(error => {
            debugger
          if (error.status === 401 || error.status === 403) {
            console.log("Unauthorized request detected in interceptor, logging out...");
            // Redirect to the homepage if unauthorized
            authService.onUnauthorized();
            return throwError(() => new Error('Session expired, try to login again'));
          }
          return throwError(() => error);
        })
      );
    }
  ));
};
